export const USER_RESTRICTIONS = {
  add_cash: 'add_cash',
  investing: 'investing',
  withdraw: 'withdraw',
};

const PORTUGAL_CODE = 'PT';

export const isPortugueseInvestor = (profile, language = '') =>
  profile?.country_code?.toUpperCase() === PORTUGAL_CODE ||
  profile?.citizenship_code?.toUpperCase() === PORTUGAL_CODE ||
  language.toLowerCase().startsWith('pt');
